<template>
    <div
        :class="
            (setClass && setClass.length
                ? 'size_img_17 text_alignment_main_box_custom'
                : 'addtext_font align_value text_alignment_main_box_custom arrow_align') +
            ' center-object-align'
        "
    >
        <div class="form-group bottom_align_items">
            <div class="layer_parent_div left_margin_zero">
                <button
                    type="button"
                    @click="setValue('left')"
                    :class="'bcommon b1 large first ' + setActive('left')"
                >
                    <img src="/maincss/images/design-studio/arrow_dash_one.svg" />
                </button>
                <button
                    type="button"
                    @click="setValue('center')"
                    :class="'bcommon large ' + setActive('center')"
                >
                    <img
                        class="center_img"
                        src="/maincss/images/design-studio/arrow_center.svg"
                        :style="'' + (!showLabel ? 'padding:6px;' : '')"
                    />
                </button>
                <button
                    type="button"
                    @click="setValue('right')"
                    :class="'bcommon b2 large last ' + setActive('right')"
                >
                    <img src="/maincss/images/design-studio/arrow_dash_two.svg" />
                </button>
            </div>
        </div>
        <!-- <label v-show="showLabel">Align</label> -->
    </div>
</template>

<script>
export default {
    /* eslint-disable */
    name: "Center",
    /* eslint-enable */
    data: () => {
        return {};
    },
    props: {
        setClass: { type: String, default: "" },
        showLabel: { type: Boolean, default: true },
        value: { type: String, default: "" }
    },
    methods: {
        setValue(e) {
            this.$emit("set-value", e);
        },
        setActive(e) {
            return e == this.value ? "active" : "";
        }
    }
};
</script>

<style>
.center_img {
    height: 18px !important;
    transform: none !important;
    min-height: 14px !important;
    object-fit: initial;
    width: 34px !important;
}

/*
 * Align row: inactive = white, active = #e8e8e8 (beats global .arrow_align .bcommon gray).
 */
.design_studio_tool #add-text .arrow_align.center-object-align button.bcommon:not(.active),
.design_studio_up
    .design_studio_tool
    #add-text
    .arrow_align.center-object-align
    button.bcommon:not(.active) {
    background: #ffffff !important;
}

.design_studio_tool #add-text .arrow_align.center-object-align button.bcommon.active,
.design_studio_up
    .design_studio_tool
    #add-text
    .arrow_align.center-object-align
    button.bcommon.active {
    background: #e8e8e8 !important;
}

.design_studio_tool
    .rt-edit-template
    .center_layering_filip
    .text_alignment_main_box_custom.center-object-align
    button.bcommon:not(.active),
.design_studio_up
    .design_studio_tool
    .rt-edit-template
    .center_layering_filip
    .text_alignment_main_box_custom.center-object-align
    button.bcommon:not(.active) {
    background: #ffffff !important;
}

.design_studio_tool
    .rt-edit-template
    .center_layering_filip
    .text_alignment_main_box_custom.center-object-align
    button.bcommon.active,
.design_studio_up
    .design_studio_tool
    .rt-edit-template
    .center_layering_filip
    .text_alignment_main_box_custom.center-object-align
    button.bcommon.active {
    background: #e8e8e8 !important;
}
.design_studio_up .design_studio_tool .bottom_align_items .bcommon{
    min-height: 20px;
}
.design_studio_up .clipart_panel .center-object-align{
   margin-left: 15px;
}
</style>
